import i18n from '../../language/index'
import {create_title} from '@/base/titleData';
import pageData from '@/base/pageData'
import {box_shadow_style_add, getBackgroundData, getSwiperSettingData, fontSet,basic_product_display_new_style, getCommonStyle} from "@/base/widgets_data_compatible";
// 标题设置
export default {
  version: 1.0,
  img_effects: {
    id: 1,
    formData: {
      effect: 0,//当前选中的特效
      border: {
        radio_val: 'default',
        default: {
          borderWidth: 2,
          borderColor: "rgba(0, 0, 0, 1)",
        },
        custom: {
          borderWidth: 2,
          borderColor: "rgba(0, 0, 0, 1)",
        }
      },
      background: {
        radio_val: 'default',
        default: {
          color: "rgba(255, 255, 255, 0)",
        },
        custom: {
          color: "rgba(255, 255, 255, 1)",
        }
      },
      direction: 'left'
    }
  },
  animateCombObj: {
    value: 0,
    animate: {
      _key: 'none'
    }
  },
  animateType: 'module_animation',
  pc_widgets_infor: {
    //图片高度
    img_size: {
      radio_val: 'default',
      default: {
        width: '100%',
        height: '90%',
      },
      custom: {
        width: '100%',
        height: '90%',
      }
    },
    // 图片大小
    pic_size: {
      radio_val: 'default',
      default: {
        width: '25%',
        height: '25%'
      },
      custom: {
        width: '25%',
        height: '25%'
      }
    },
    //图片缩放
    backgroundSize: {
      radio_val: 'default',
      default: {
        backgroundSize: 'cover'
      },
      custom: {
        backgroundSize: 'auto'
      }
    },
    borderRadius: {
      ...getCommonStyle().borderRadius
    },
    //标题对象
    title: create_title('Product list'),
    textAlign: 'left',
    showSummary: 'false',
    page: pageData,
    //每行个数
    col_num: {
      radio_val: 'default',
      default: {
        value: 4,
      },
      custom: {
        value: 4,
      }
    },

    //每行间距
    padding: {
      radio_val: 'default',
      default: {
        paddingTop: 20,
        paddingLeft: 20,
      },
      custom: {
        paddingTop: 20,
        paddingLeft: 20,
      }
    },
    // 跳转方式 _blank 新窗口 _self 当前窗口
    target: '_blank',
    search_is_open: 'true',
    cate_cont_show: 'true', //分类是否显示
    // 显示个数
    showNum: 1,
    showAll: true,
    // 4.6.7 组合阴影 添加
    ...box_shadow_style_add(),
    ...getBackgroundData(),
    ...getSwiperSettingData(),
    // 添加标题文字
    product_name_font: {
      ...fontSet(),
      default: {
        ...fontSet().default,
        fontSize: 16,
      },
      custom: {
        ...fontSet().custom,
        fontSize: 16,
      }
    },
    ...basic_product_display_new_style()
  },
  mb_widgets_infor: {
    //标题对象
    title: create_title('Product list'),
    //每行个数
    col_num: {
      radio_val: 'default',
      default: {
        value: 2,
      },
      custom: {
        value: 2,
      }
    },
    ...basic_product_display_new_style()
  },
  listArr: {
    type: 'custom',
    module_style: 0,
    //直接添加的 
    custom: [],
    //筛选条件-产品分类
    catalog_id: [],
    sortBy: 'default',
    sort: 'desc', // asc desc
    // 参数列表
    paraList: [
      {
        title: i18n.t('widgets_basic_product_detail_style_2771'),
        id: 'brand',
        show: false
      },
      {
        title: i18n.t('widgets_basic_product_detail_style_2772'),
        id: 'model',
        show: false
      },
      {
        title: i18n.t('components_basic_addproduct_sales_2141'),
        id: 'standard',
        show: false
      },
      {
        title: i18n.t('widgets_basic_product_detail_style_2773'),
        id: 'minimum',
        show: false
      },
      {
        title: i18n.t('widgets_basic_product_detail_style_2775'),
        id: 'pack',
        show: false
      }
    ],
    type_system: true // 4.7.18 数据来源是否有系统推荐
  },
  isSystem: 'false',
  thumbnailWidth: ''
}



// WEBPACK FOOTER //
// ./src/widgets/basic_product_display/style.js